import { render, staticRenderFns } from "./xfans_footer.vue?vue&type=template&id=c082e6da&scoped=true&"
import script from "./xfans_footer.vue?vue&type=script&lang=js&"
export * from "./xfans_footer.vue?vue&type=script&lang=js&"
import style0 from "./xfans_footer.vue?vue&type=style&index=0&id=c082e6da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c082e6da",
  null
  
)

export default component.exports